import { DOCTYPES } from '@/constants/doctypes'
import { createDoctypeRoutes } from '@/routers/routes/createDoctypeRoutes'

const {
  create: routeRoleCreate,
  detail: routeRoleDetail,
  home: routeRoleSettingsHome,
  root: routeRoleSettingsRoot,
} = createDoctypeRoutes({
  createName: 'new-role',
  createPath: 'new-role',
  detailName: 'roleDetail',
  doctype: DOCTYPES.TW_ROLE,
  homeName: 'role-settings-home',
  path: 'role',
  views: {
    create: async () => await import('@/components/viewsExternal/twRole/AddTwRole.vue'),
    detail: async () => await import('@/components/viewsExternal/twRole/ViewTwRole.vue'),
    list: async () => await import('@/components/viewsExternal/settings/brm/ViewBRMSettings.vue'),
  },
})

export { routeRoleCreate, routeRoleDetail, routeRoleSettingsHome, routeRoleSettingsRoot }
